<template>
  <v-dialog v-model="showWindow" scrollable max-width="90%" persistent>
    <v-card height="100%" class="pa-2" :loading="!isFetchedOrder">
      <v-row class="fill-height ma-0 pa-0">
        <v-col cols="8">
          <v-flex ma-0 pa-0 pb-2>
            <v-btn
                    color="primary"
                    class="mr-3"
                    elevation="0"
                    @click="setToday">
              {{ $t('viewCalendar.today') }}
            </v-btn>
            <v-btn
                    fab
                    elevation="0"
                    small
                    @click="$refs.calendar.prev()"
            >
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-menu
                    v-if="$refs.calendar"
                    v-model="calendarDatePickerVisible"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                        v-bind="attrs"
                        v-on="on"
                >
                  <span class="dashed mx-4">
                    {{ $moment(currentCalendarDate).format("DD.MM.YYYY") }}
                  </span>
                </span>
              </template>
              <v-date-picker
                      :first-day-of-week="first_day_of_week"
                      v-model="calendarDate"
                      @input="calendarDatePickerVisible = false; "
                      :locale="locale"
              >

              </v-date-picker>
            </v-menu>
            <v-btn
                    fab
                    elevation="0"
                    small
                    @click="$refs.calendar.next()"
            >
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-progress-circular
                    indeterminate
                    size="20"
                    color="primary"
                    v-if="!fetched"
            ></v-progress-circular>
          </v-flex>
          <v-sheet height="700" v-if="order">
            <v-calendar
                ondragover="return event.preventDefault();"
                :first-time="calendarDayStartTime"
                :interval-count="calendarIntervalCount"
                weekdays="[1, 2, 3, 4, 5, 6, 0]"
                :locale="locale"
                ref="calendar"
                v-model="calendarDate"
                color="primary"
                type="category"
                category-show-all
                :categories="posts.map(current => current.name)"
                :events="computedIntervals"
                :event-color="getEventColor"
                @mousedown:event="startDrag"
                @mousedown:time="startTime"
                @mousemove:time-category="mouseMove"
                @mouseup:time="endDrag"
                @mouseleave.native="cancelDrag"
                @change="fetchEvents"
            >
              <template #category-column="{ category }">
                1
              </template>
              <template #category="{ category }">
                <div class="text-center text-caption d-flex justify-center align-content-center" >

                  <img class="px-1" v-if="posts && posts.find(
                      (current) => current.name === category
                  ) && posts.find(
                      (current) => current.name === category
                  ).post_icon" height="18" :src="postIconPath + posts.find(
                      (current) => current.name === category
                  ).post_icon.file"/>
                  {{category}}
                  <v-icon
                      :title="$t('viewCalendar.post_is_disabled')"
                      x-small
                      color="error"
                      v-if="posts && posts.find(
                      (current) => current.name === category
                  ) && posts.find(
                      (current) => current.name === category
                  ).active != 1">fa-ban</v-icon>
                </div>
              </template>
              <template #day-label-header="{ date, week }">
                <span></span>
              </template>
              <template #day-body="{ date, week }">
                <div
                    v-if="isTodayCurrentCalendarDate"
                    class="v-current-time"
                    :class="{ first: date === week[0].date }"
                    :style="{ top: nowY }"
                ></div>
              </template>
              <template #event="{ event, eventParsed }">
                <div class="eventWrap black--text" ondragover="return false;" :style="{'min-height':(ready && $refs.calendar ? $refs.calendar.minutesToPixels(event.duration) : 0)+'px'}">
                  <div class="d-flex">
                  <v-icon color="black" small class="px-1 fitContent" @click="removeNewFromCalendar(event)" v-if="event.order_id === orderId">fa-times</v-icon>
                  <span class="fitContent darken-1 blue-grey white--text rounded-sm px-1" :title="timeTitle(eventParsed)">
                    {{timeForShow(eventParsed)}}
                  </span>
                  <user-profile-photo :title="event.repairer.name" v-if="event.repairer" :profile-photo="event.repairer.profile_photo" :size="18"></user-profile-photo>
                  </div>
                    <div class="repairtimeName" :title="event.repairtime_name">{{
                      event.repairtime_name
                    }}
                  </div>
                </div>
              </template>
            </v-calendar>
          </v-sheet>
        </v-col>
        <v-col cols="4">
          <!-- order info--->
          <template v-if="order">
            <h3>{{$t('viewOrdersForm.title')}} {{order.human_number}}:</h3>
            <p class="ma-0 " v-if="order.customer && order.customer.is_company==1">
              {{$t('common.legal_name')}}: <strong>{{order.customer.is_company==1 ? '['+order.customer.legal_name+']' : ''}}</strong>
            </p>
            <p class="ma-0 ">
              {{$t('common.customer')}}:
              <strong v-if="order.customer">{{ order.customer.last_name }} {{ order.customer.first_name }} {{ order.customer.patronymic }}</strong>
              <strong v-else>{{ $t("viewOrders.customer_is_deleted") }}</strong>
            </p>
            <p v-if="order.customer" class="ma-0">{{$t('common.customer_type')}}: <strong>{{ order.customer.customer_type ? order.customer.customer_type.name : '-' }}</strong></p>
            <p v-if="order.customer" class="ma-0">{{$t('common.phone')}}: <strong>{{ order.customer.phone }}</strong></p>
            <p v-if="order.customer" class="ma-0">{{$t('common.email')}}: <strong><a :href="'mailto:'+order.customer.email">{{ order.customer.email }}</a></strong></p>
            <p class="ma-0">{{$t('common.car')}}:
              <strong>
                {{order.car ? (order.car.name ) : ''}}<beauty-car-number v-if="order.car && order.car.car_number" :number="order.car.car_number"></beauty-car-number>
                <span v-if="!order.car">{{$t('common.not_selected')}}</span>
              </strong>
            </p>
            <p class="ma-0">{{$t('viewOrders.tableHeader.created_at')}}: <strong>{{ order.created_at | moment("DD.MM.YYYY") }} {{ order.created_at | moment("HH:mm") }}</strong></p>
            <p class="ma-0">{{$t('viewOrders.tableHeader.total_sum')}}: <strong>{{ formatCurrency(order.total_sum) }}</strong></p>
            <!--- list of repairtimes -->
            <span v-if="showWindow" id="dragToCalendarForAttachingPlaceholder"></span>
            <h3 v-if="repairtimes && repairtimes.length>0">{{ $t('viewCalendar.unplanned_repairtimes') }}:</h3>
            <i v-if="repairtimes && repairtimes.length>0">{{ $t('viewCalendar.drag_to_calendar_for_attaching') }}</i>
            <v-card v-for="repairtime in repairtimes" draggable="true" @dragstart="startDrag(repairtime)" class="grabbable pa-2 mb-3 pb-0" v-if="orderId && isFetchedOrder">
              <v-icon>fa-arrow-left</v-icon><v-icon x-small>fa-tools</v-icon> {{repairtime.name}} <i v-if="repairtime.amount > 1">(x{{repairtime.amount}})</i>
                <v-container class="pa-0 ma-0">
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                    v-model="repairtime.duration"
                                    :label="$t('viewCalendar.plan_time_in_minutes')"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="8">
                            <v-select
                                    :label="$t('viewCalendar.repairer')"
                                    :items="users"
                                    item-text="name"
                                    return-object
                                    v-model="repairtime.repairer"
                                    class="pointer"
                                    clearable
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>

            <!--- list of repairtimes with interval -->
            <h3 v-if="repairtimesWithIntervals && repairtimesWithIntervals.length>0" id="hasRepairtimesWithIntervals">
              {{ $t('viewCalendar.repairtimes_in_calendar') }}
            </h3>
            <span v-for="repairtimeWithInterval in repairtimesWithIntervals.sort(compareRepairtimesDateForSort)" class="d-block">
              <v-icon small class="mr-1" @click="repairtimeWithInterval.interval=null">fa-times</v-icon>
              <span @click="calendarDate=formatDateObjToStr(repairtimeWithInterval.interval.start, repairtimeWithInterval.interval.end).substring(0, 10)">
                {{formatDateObjToStr(repairtimeWithInterval.interval.start, repairtimeWithInterval.interval.end)}}
              </span>
              {{repairtimeWithInterval.name}}
              <user-profile-photo :title="(repairtimeWithInterval.repairer && repairtimeWithInterval.repairer.name || '')" class="mr-1" v-if="repairtimeWithInterval.repairer" :profile-photo="repairtimeWithInterval.repairer.profile_photo" :size="18"></user-profile-photo>
              {{(repairtimeWithInterval.repairer && repairtimeWithInterval.repairer.name || '')}}
            </span>
          </template>
        </v-col>
      </v-row>
      <v-divider class="mt-4 mb-2 mx-2"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :loading="savingInProgress || !isFetchedOrder"
            :disabled="savingInProgress || !isFetchedOrder"
            color="red"
            class="white--text"
            @click="showWindow = false"
            @keyup.enter="showWindow = false"
            elevation="0"
        >
          {{ $t("common.close") }}
        </v-btn>
        <v-btn
            id="saveIntervalsBtn"
            class="white--text "
            depressed color="primary"
            @click="submit"
            :loading="savingInProgress || !isFetchedOrder"
            :disabled="savingInProgress || !isFetchedOrder"
        >{{$t('common.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import {mapFields} from 'vuex-map-fields';
import CommonMixin from "@/mixins/common";
import CalendarMixin from "@/mixins/calendar";
import BeautyCarNumber from "../common/BeautyCarNumber";
import UserProfilePhoto from "@/components/user/UserProfilePhoto";

export default {
  name: "CalendarForm",
  components: {UserProfilePhoto, BeautyCarNumber},
  mixins: [CommonMixin, CalendarMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: Number,
      default: false
    }
  },
  data: () => ({
    calendarDate: null,
    calendarDatePickerVisible: false,
    todayDate: null,
    nowY: null,
    ready: false,
    order: null,
    isTodayCurrentCalendarDate: false
  }),
  computed: {
    ...mapFields("auth", ["authenticatedUser"]),    
    ...mapFields("orders", ["savingInProgress", "isFetchedOrder"]),
    ...mapFields("posts", ["posts"]),
    ...mapFields('users', ['users']),
    ...mapFields('intervals', ['intervals', 'fetched']),
    /**
     * Время начала работы в текущий(this.calendarDate) день
     */
     calendarDayStartTime(){            
      return this.getShopDayStartByDate(this.calendarDate)
    },
    /**
     * Продолжительность рабочего дня в часах, округлено в большую сторону
     */
    calendarIntervalCount(){
      const workingHours = this.authenticatedUser.shop.working_hours;
      const dayName = this.getDayNameByDate(this.calendarDate);
      const startTime = workingHours[`${dayName}_start`];
      const endTime = workingHours[`${dayName}_end`];
      const startDateTime = new Date(this.calendarDate+"T"+startTime);
      const endDateTime = new Date(this.calendarDate+"T"+endTime);

      const intervalInMilliseconds = endDateTime.getTime() - startDateTime.getTime();
      const intervalInSeconds = intervalInMilliseconds / 1000;
      const intervalInMinutes = intervalInSeconds / 60;
      const intervalInHours = intervalInMinutes / 60;
      return Math.ceil(intervalInHours);
    },  

    currentCalendarDate(){
      let val = this.$refs.calendar && this.$refs.calendar.parseTimestamp(this.$refs.calendar.value);
      return val && val.date;
    },
    computedIntervals(){
      if(!this.order) return [];
      let intervalsFromCurrentOrder = [];
      let idsOfIntervalsFromCurrentOrder = [];
      let repairtimes = this.order.items.filter((item) => {
        return item.item_type === 'repairtime';
      });
      repairtimes.forEach((item)=>{
        if(item.interval){
          item.interval.category = item.interval.post.name;
          item.interval.repairtime_name = item.name;
          item.interval.timed = true;
          item.interval.order_id = this.order.id;
          intervalsFromCurrentOrder.push(item.interval);
        }
      })
      let otherIntervals = this.intervals.filter((item)=>item.repairtime.order.id !== this.orderId)
      otherIntervals = otherIntervals.map((current) => {
        let brand = current.repairtime && current.repairtime.order && current.repairtime.order.car && current.repairtime.order.car.brand || 'none';
        let car_number = current.repairtime && current.repairtime.order && current.repairtime.order.car && current.repairtime.order.car.car_number || null;
        let order_human_number = current.repairtime && current.repairtime.order && current.repairtime.order.human_number || null;
        let order_id = current.repairtime && current.repairtime.order && current.repairtime.order.id || null;
        let repairtime_name = current.repairtime && current.repairtime.name || null;
        let status_color = current.repairtime && current.repairtime.status && current.repairtime.status.color || null;
        return {
          "order_item_id": current.repairtime.id,
          "duration": current.repairtime && current.repairtime.duration || 0,
          "start": Date.parse(current.start),
          "end": Date.parse(current.end),
          "color": "indigo",
          "timed": true,
          "category": current.post.name,
          "brand": brand,
          "car_number": car_number,
          "order_human_number": order_human_number,
          "order_id": order_id,
          "repairtime_name": repairtime_name,
          "status_color": status_color,
        };
      });
      return otherIntervals.concat(intervalsFromCurrentOrder);
    },
    repairtimesWithIntervals() {
      return this.order.items.filter((item) => {
        let item_start = (typeof item.start==="string")  ? Date.parse(item.start) : item.start;
        let item_end = (typeof item.end==="string")  ? Date.parse(item.end) : item.end;
        item.start = item_start;
        item.end = item_end;
        return item.item_type === 'repairtime' && item.interval;
      });
    },
    repairtimes() {
      let repairtimes = this.order.items.filter((item) => {
        return item.item_type === 'repairtime' && !item.interval;
      });
      return repairtimes.map((item)=>{
        if(!item.duration){
            let the_15_min_in_ms = 900000;
            let repairtimeDurationInMilliseconds  = Math.round(item.amount * item.time*60*60*1000);
            repairtimeDurationInMilliseconds = (repairtimeDurationInMilliseconds < the_15_min_in_ms) ? the_15_min_in_ms : repairtimeDurationInMilliseconds;
            item.duration = Math.round(repairtimeDurationInMilliseconds / 1000 / 60);
            item.duration = Math.ceil(item.duration/15)*15; //округлим полученное до 15 минут
        }
        return item;
      });
    },
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.setToday();
        this.$emit('hide')
      }
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
  },
  mounted() {
    this.ready = true;
    let today = new Date();
    let day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
    this.todayDate = `${today.getFullYear()}-${((today.getMonth() + 1)<10)?(0):('')}${(today.getMonth() + 1)}-${day}`;
    this.setToday();
  },
  methods: {
    getShopDayStartByDate(date){
      let workingHours = this.authenticatedUser.shop.working_hours;
      let dayName = this.getDayNameByDate(date);
      return workingHours[`${dayName}_start`];
    },
    getDayNameByDate(dateString){
      const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      const date = new Date(dateString);
      return daysOfWeek[date.getDay()];      
    },    
    async submit(){
      this.$store.dispatch('orders/ordersUpdate', this.order).then(async (updatedOrder)=>{
        this.$store.dispatch('intervals/get', {date: this.todayDate});
        this.order = await this.$store.dispatch('orders/orderShow', {id: this.orderId})
        this.$store.dispatch('posts/get');
        if(updatedOrder && updatedOrder.id>0) {
          this.showWindow = false;
        }
      })
    },
    removeNewFromCalendar(el){
      this.order.items.map((item)=>{
        if(item.id===el.order_item_id){
          item.interval = null;
        }
      })

    },
    hasRepairtimeOnPeriod(toDateStart, toDateEnd, postName, currentOrderItemId){
      return this.computedIntervals.filter((item)=>{
        let item_start = (typeof item.start==="string")  ? Date.parse(item.start) : item.start;
        let item_end = (typeof item.end==="string")  ? Date.parse(item.end) : item.end;
        if(item.order_item_id === currentOrderItemId) return false; //если это текущий элемент
        if(item.category != postName) return false;
        if(item_start > Date.parse(toDateStart) && item_start < Date.parse(toDateEnd)){
          return true;
        }
        if(item_start > Date.parse(toDateStart) && item_end <= Date.parse(toDateEnd) || Date.parse(toDateStart) >= item_start && Date.parse(toDateStart) < item_end){
          return true;
        }
        return false;
      }).length > 0;
    },
    fetchEvents({start, end}) {

    },
    getEventColor(event) {
      return event.order_id === this.orderId ? "blue-grey lighten-5" : "blue-grey lighten-5 past"
    },
    setToday() {
      this.calendarDate = this.todayDate;
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    getCurrentTime() {
      return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
    },
    scrollToTime() {
      const time = this.getCurrentTime()
      const first = Math.max(0, time - (time % 30) - 30)

      this.cal.scrollToTime(first)
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000)
    },
    formatDateObjToStr(start, end){
      start = (typeof start==="string")  ? new Date(Date.parse(start)) : start;
      end = (typeof end==="string")  ? new Date(Date.parse(end)) : end;
      let startDate = `${start.getFullYear()}-${(start.getMonth()+1)<10 ? '0'+(start.getMonth()+1) : (start.getMonth()+1) }-${start.getDate()}`;
      let endDate = `${start.getFullYear()}-${(end.getMonth()+1)<10 ? '0'+(end.getMonth()+1) : (end.getMonth()+1) }-${end.getDate()}`;
      let startTime = start.getHours() + ':' + (start.getMinutes()<10 ? '0'+start.getMinutes() : start.getMinutes());
      let endTime = end.getHours() + ':' + (end.getMinutes()<10 ? '0'+end.getMinutes() : end.getMinutes());

      let startDateFormatted = this.$moment(startDate).format(this.dateFormat);
      let endDateFormatted = this.$moment(endDate).format(this.dateFormat);

      return (startDate===endDate) ? `${startDateFormatted} ${startTime} - ${endTime}` : `${startDateFormatted} ${startTime} - ${endDateFormatted} ${endTime}`
    },
    startDrag(event) {
      if (event) {
        this.dragEvent = event
        this.dragTime = null
        this.extendOriginal = null
      }

    },
    startTime(tms) {
      const mouse = this.toTime(tms);
      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start
        this.dragTime = mouse - start
      }
    },
    extendBottom(event) {
      this.createEvent = event
      this.createStart = event.start
      this.extendOriginal = event.end
    },
    mouseMove(tms) {
      const the_15_min_in_ms = 900000;
      const mouse = this.toTime(tms);
      let dateObj = new Date();
      let currentTimeZoneOffset = dateObj.getTimezoneOffset()*60*60*20;
      const mouseRounded = this.roundTime(mouse+currentTimeZoneOffset, false)

      if (this.dragEvent && this.dragEvent.event && this.dragEvent.event.order_id === this.orderId) { //перетаскивание в календаре
        let start = this.$refs.calendar.timestampToDate(this.$refs.calendar.parseTimestamp(this.dragEvent.event.start));
        let end = this.$refs.calendar.timestampToDate(this.$refs.calendar.parseTimestamp(this.dragEvent.event.end));
        let duration = end - start;

        let startDate = this.$refs.calendar.timestampToDate(this.$refs.calendar.parseTimestamp(mouseRounded));
        let endDate = this.$refs.calendar.timestampToDate(this.$refs.calendar.parseTimestamp(this.roundTime(mouseRounded+duration)));
        if(!this.hasRepairtimeOnPeriod(startDate, endDate, tms.category, this.dragEvent.event.order_item_id)){
          this.dragEvent.event.start = startDate;
          this.dragEvent.event.end = endDate;
          this.dragEvent.event.category = tms.category;
          this.dragEvent.event.post = this.posts.filter(current => current.name===tms.category)[0];
        }
      }
      if (this.dragEvent && this.dragEvent.amount) { //перетаскиваем новую работу из списка в календарь
        let brand = this.order && this.order.car && this.order.car.brand || 'none';
        let car_number = this.order && this.order.car && this.order.car.car_number || null;
        let order_human_number = this.order && this.order.human_number || null;
        let order_id = this.order && this.order.id || null;
        let repairtime_name = this.dragEvent.name || null;

        let repairtimeDurationInMilliseconds = this.dragEvent.duration * 60 * 1000;
        repairtimeDurationInMilliseconds = (repairtimeDurationInMilliseconds < the_15_min_in_ms) ? the_15_min_in_ms : repairtimeDurationInMilliseconds;
        let startDate = this.$refs.calendar.timestampToDate(this.$refs.calendar.parseTimestamp(mouseRounded));
        let endDate = this.$refs.calendar.timestampToDate(this.$refs.calendar.parseTimestamp(this.roundTime(mouseRounded+repairtimeDurationInMilliseconds)));

        if (this.posts.find(current => current.name===tms.category).active == 0) {
          this.dragEvent = null;
          this.$store.dispatch("intervals/get", {
            date: this.currentCalendarDate,
          });

          this.$store.dispatch("common/showError", {
            error: this.$t("viewCalendar.post_is_disabled"),
          });
          return;
        }
        if(!this.hasRepairtimeOnPeriod(startDate, endDate, tms.category, this.dragEvent.id)) {
              this.order.items.filter((item) => {
                return item.id == this.dragEvent.id;
              })[0].interval = {
                  "order_item_id": this.dragEvent.id,
                  "name": "audi 100",
                  "start": startDate,
                  "end": endDate,
                  "color": "indigo",
                  "timed": true,
                  "category": tms.category,
                  "post": this.posts.find(current => current.name===tms.category),
                  "brand": brand,
                  "car_number": car_number,
                  "order_human_number": order_human_number,
                  "order_id": order_id,
                  "repairtime_name": repairtime_name,
                  "repairer": this.dragEvent.repairer
                  // "Мастер"
                  // "Наименование работы + номер заказа"
                };

              this.dragEvent = null;
          }
      }
    },
    async endDrag() {
      if (this.dragEvent.event.post.active == 0) {
        this.order = await this.$store.dispatch('orders/orderShow', {id: this.orderId})
        this.$store.dispatch("intervals/get", {
          date: this.currentCalendarDate,
        });

        this.$store.dispatch("common/showError", {
          error: this.$t("viewCalendar.post_is_disabled"),
        });
      }
      this.dragTime = null
      this.dragEvent = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
    },
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal
        } else {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1)
          }
        }
      }

      this.createEvent = null
      this.createStart = null
      this.dragTime = null
      this.dragEvent = null
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    toTime(tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
  },
  watch: {
    calendarDate(to, from) {
      this.isTodayCurrentCalendarDate = (new Date()).toISOString().split('T')[0] === to;
      if(this.show){
        this.$store.dispatch('intervals/get', {date: to});
      }
      this.nowY = this.$refs.calendar ? this.$refs.calendar.timeToY(this.cal.times.now) + 'px' : '-10px';
    },
    async show(to, from) {

      if (to) {
        this.order = await this.$store.dispatch('orders/orderShow', {id: this.orderId})
        this.$store.dispatch('posts/get');
        this.$store.dispatch('users/get');
        this.$store.dispatch('intervals/get', {date: this.todayDate}).then(()=>{
          this.nowY = this.$refs.calendar ? this.$refs.calendar.timeToY(this.cal.times.now) + 'px' : '-10px';
        })
      }
    }
  }
}
</script>

<style lang="css">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

}

.v-calendar-category__columns .v-calendar-category__column:first-child .v-current-time.first::before {
  content: '';
  position: absolute;
  background-color: #ea4335;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: -5px;
  margin-left: -6.5px;
}

.eventWrap:hover {
  /*border:1px solid #a8a8a8;*/
}
.eventWrap {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.brandLogo {
  height: 18px;
  margin-top: 1px;
}

.v-calendar-daily_head-weekday {
  display: none !important;
}

.grabbable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.v-calendar-daily__day:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.v-event-timed{
  border-radius: 0 !important;
}
.v-event-timed:hover{
  z-index:10000;
  width:inherit !important;
  min-width: 100%;

  height: auto !important;
  padding:2px;
  border:1px solid transparent;
}

.v-event-timed .repairtimeName{white-space: normal;}

.fitContent{
  height: fit-content;
}
</style>